/**
 * Extracts the current count for local saved elements (e.g. the count of the
 * product comparison).
 *
 * @param {string} amiradaCountry
 * @param {Storage} storage
 * @returns {Record<string, number>}
 */
export function getListCounts(amiradaCountry, storage = localStorage) {
  return Object.fromEntries(
    Object.keys(storage)
      .filter(
        (key) => key.startsWith(amiradaCountry) && key.includes("listCount")
      )
      .map((key) => {
        const pieces = key.split("_");
        const count = parseInt(storage[key], 10);

        return [pieces.at(-1), count];
      })
  );
}
